<div
   class="settings-backdrop"
   (click)="close()"></div>

<div
   class="settings-modal"
   (click)="$event.stopPropagation()">
   <div class="settings-header">
      <div class="settings-title-wrap">
         <div class="settings-title-icon">
            <i class="fa fa-gear"></i>
         </div>
         <div>
            <div class="settings-title">Settings</div>
         </div>
      </div>

      <button
         class="settings-close"
         type="button"
         (click)="close()"
         aria-label="Close settings">
         <i class="fa fa-times"></i>
      </button>
   </div>

   <div class="settings-nav">
      <button
         type="button"
         class="settings-nav-item"
         [class.active]="activeTab === 'roles'"
         (click)="setTab('roles')">
         <i class="fa fa-shield-halved"></i>
         Roles &amp; Permissions
      </button>

      <button
         type="button"
         class="settings-nav-item"
         [class.active]="activeTab === 'reminders'"
         (click)="setTab('reminders')">
         <i class="fa-regular fa-clock"></i>
         Reminders
      </button>

      <div class="settings-nav-divider"></div>

      <button
         type="button"
         class="settings-nav-item"
         [class.active]="activeTab === 'messages'"
         (click)="setTab('messages')">
         <i class="fa-regular fa-message"></i>
         Messages
         <span
            class="settings-count-badge"
            *ngIf="messageAttentionCount > 0">
            {{ messageAttentionCount }}
         </span>
      </button>
   </div>

   <div class="settings-content">
      <!-- ROLES & PERMISSIONS -->
      <div
         class="settings-pane settings-role-pane"
         *ngIf="activeTab === 'roles'">
         <app-role-permissions></app-role-permissions>
      </div>

      <!-- REMINDERS -->
      <div
         class="settings-pane settings-reminders-pane"
         *ngIf="activeTab === 'reminders'">
         <div
            class="settings-loading"
            *ngIf="remindersLoading">
            Loading reminders…
         </div>

         <div
            class="settings-error"
            *ngIf="remindersError">
            {{ remindersError }}
         </div>

         <div
            class="settings-reminder-layout"
            *ngIf="!remindersLoading && !remindersError">
            <!-- LEFT LIST -->
            <div class="settings-reminder-list">
               <div class="settings-reminder-list-head">
                  <div>Reminder</div>
                  <div class="settings-reminder-active-head">Enabled</div>
               </div>

               <button
                  type="button"
                  class="settings-reminder-row"
                  *ngFor="let item of reminderItems"
                  [class.active]="selectedReminderItem === item"
                  [class.off]="!isReminderOn(item)"
                  (click)="selectReminder(item)">
                  <div class="settings-reminder-row-copy">
                     <div class="settings-reminder-row-title">{{ item.definition.label }}</div>
                     <div class="settings-reminder-row-subtitle">{{ reminderListSubtitle(item) }}</div>
                  </div>
                  <div class="settings-reminder-row-toggle">
                     <span
                        class="rm-switch rm-switch-sm"
                        [class.rm-switch-off]="!isReminderOn(item)"
                        (click)="toggleReminderEnabled(item, $event)"></span>
                  </div>
               </button>
            </div>

            <!-- EXISTING REMINDER EDITOR -->
            <div
               class="settings-reminder-detail"
               *ngIf="activeReminder as current">
               <div class="settings-reminder-detail-head">
                  <div>
                     <div class="settings-reminder-detail-title">{{ activeReminderDef.label }}</div>
                     <div
                        class="settings-reminder-detail-subtitle"
                        style="font-size: 12px">
                        {{ reminderHeaderSubtitle }}
                     </div>
                  </div>
                  <div
                     class="rm-switch-wrap"
                     [style.background]="current.isEnabled ? '#1a9e82' : '#c5cdcc'"
                     [style.border]="current.isEnabled ? '1px solid #1a9e82' : '1px solid #bec6c5'">
                     <span class="rm-switch-label">{{ current.isEnabled ? "Enabled" : "Disabled" }}</span>
                  </div>
               </div>

               <div class="settings-reminder-editor-grid">
                  <div class="rm-editor">
                     <div class="rm-field-label">Send to</div>
                     <div class="rm-chip-row">
                        <button
                           type="button"
                           class="rm-chip"
                           *ngFor="let role of activeReminderDef.recipientOptions"
                           [class.rm-chip-on]="isReminderRecipient(role)"
                           (click)="toggleReminderRecipient(role)">
                           <ng-container *ngIf="isReminderRecipient(role)">{{ role }} ✕</ng-container>
                           <ng-container *ngIf="!isReminderRecipient(role)">+ {{ role }}</ng-container>
                        </button>
                     </div>

                     <div class="rm-field-label">Subject</div>
                     <input
                        class="rm-input"
                        type="text"
                        [(ngModel)]="current.subject"
                        placeholder="Subject line" />

                     <div class="rm-field-label">Body</div>
                     <div class="rm-body-wrap">
                        <textarea
                           #reminderBody
                           class="rm-body-input"
                           spellcheck="true"
                           [(ngModel)]="current.body"
                           placeholder="Write the email. Use the tokens below to fill in each person's details."></textarea>
                     </div>

                     <div class="rm-insert-row">
                        <span class="rm-insert-label">Insert:</span>
                        <button
                           type="button"
                           class="rm-insert-token"
                           *ngFor="let token of activeReminderDef.tokens"
                           (click)="insertReminderToken(token)">
                           {{ token }}
                        </button>
                     </div>
                  </div>

                  <div class="rm-preview">
                     <div class="rm-field-label">Preview{{ current.sampleName ? " · " + current.sampleName : "" }}</div>

                     <div class="rm-preview-card">
                        <div
                           class="rm-preview-subject"
                           *ngIf="reminderPreviewSubject">
                           {{ reminderPreviewSubject }}
                        </div>
                        <p
                           class="rm-preview-line"
                           *ngFor="let line of reminderPreviewLines">
                           {{ line }}
                        </p>
                        <div
                           class="rm-preview-empty"
                           *ngIf="!current.body">
                           Nothing to preview yet.
                        </div>
                     </div>

                     <div class="rm-preview-meta">{{ reminderLastSentLine }}</div>
                  </div>
               </div>

               <div class="settings-reminder-footer">
                  <button
                     class="v-button v-button-md v-darkgreen-border"
                     style="border-color: #acc9c9"
                     [disabled]="remindersSendingTest || !activeReminder"
                     (click)="sendReminderTest()">
                     <i class="fa fa-paper-plane"></i>
                     &nbsp;{{ remindersSendingTest ? "Sending…" : "Send test to me" }}
                  </button>
                  <button
                     class="v-button v-button-md v-darkgreen-border"
                     style="border-color: #acc9c9"
                     [disabled]="remindersSaving || !activeReminder"
                     (click)="saveReminderTemplate()">
                     <i class="fa fa-download"></i>
                     &nbsp;{{ remindersSaving ? "Saving…" : "Save template" }}
                  </button>
                  <button
                     class="v-button v-button-md v-teal"
                     [disabled]="!canSendReminder"
                     (click)="sendRemindersToAll()">
                     <i class="fa fa-envelope-circle-check"></i>
                     &nbsp;{{ remindersSending ? "Sending…" : reminderSendLabel }}
                  </button>
               </div>
            </div>
         </div>
      </div>

      <!-- MESSAGES -->
      <div
         class="settings-pane settings-messages-pane"
         *ngIf="activeTab === 'messages'">
         <app-admin-messages
            (attentionCountChange)="onMessageAttentionCountChange($event)"
            (openContext)="openMessageContext.emit($event)"></app-admin-messages>
      </div>
   </div>
</div>
